import React from 'react'

import { ReactPortal } from '../ReactPortal'
import CloseIcon from './assets/close.svg'

import S from './styles'

type TDialogProps = {
  children: React.ReactNode
  isVisible: boolean
  closeId: string
  onClose: () => void
}

const Dialog = ({ children, isVisible, closeId, onClose }: TDialogProps) => {
  const closeModal = () => {
    onClose()
  }

  if (!isVisible) {
    return null
  }

  return (
    <ReactPortal containerId='modal-root'>
      <S.Wrapper>
        <S.Overlay onClick={closeModal} />

        <S.Dialog>
          <S.Close id={closeId} onClick={closeModal}>
            <img src={CloseIcon} alt="Ícone no formato da letra X" />
          </S.Close>
          {children}
        </S.Dialog>
      </S.Wrapper>
    </ReactPortal>
  )
}

export default Dialog
